import type { FC } from 'react';

import { ReadOnlyGroupList } from '@/components/UI/GroupList/ReadOnlyGroupList';
import { _isEmpty } from '@/littledash';
import type { TaskTarget } from '@/model/Task.model';
import type { TreatmentGroup } from '@/model/TreatmentGroup.model';

import { OverviewGroupDetailsEmptyState } from './OverviewGroupDetailsEmptyState';

interface OverviewGroupDetailsContentProps {
  target: TaskTarget;
  targetGroups: Array<TreatmentGroup>;
  emptyMessage?: string;
}

/**
 * Body of the overview group details modal. Lists the resolved treatment groups,
 * or an empty state when the target has no matching groups.
 */
export const OverviewGroupDetailsContent: FC<OverviewGroupDetailsContentProps> = ({
  target,
  targetGroups,
  emptyMessage = 'No groups found for this task',
}) => {
  if (target.type === 'animal') {
    return <OverviewGroupDetailsEmptyState message="This task targets all animals" />;
  }

  if (_isEmpty(targetGroups)) {
    return <OverviewGroupDetailsEmptyState message={emptyMessage} />;
  }

  return (
    <div data-test-component="OverviewGroupDetails" data-test-element="groups">
      <ReadOnlyGroupList groups={targetGroups} />
    </div>
  );
};
